import React from 'react'
import { createPortal } from 'react-dom'
import { RouterProvider } from 'react-router'
import { ToastContainer } from 'react-toastify'
import { useSetAtom } from 'jotai/react'

import { inviterAtom } from '@/stores/services'

import { TooltipProvider } from './components/ui/tooltip'
import useHelper from './hooks/useHelper'
import useMediaQuery from './hooks/useMediaQuery'
import useRem from './hooks/useRem'
import useWatcher from './hooks/useWatcher'
import { getUrlParams } from './lib/utils'
import router from './routes'

const App: React.FC = () => {
  const { gtXL } = useMediaQuery()
  useWatcher()
  useRem()
  useHelper()
  const setInviter = useSetAtom(inviterAtom)

  React.useLayoutEffect(() => {
    const inviter = getUrlParams('inviter');
    if (inviter) {
      setInviter(inviter)
    }
  }, [])

  return (
    <>
      {createPortal(
        <div className="Toastify-Wrapper">
          <ToastContainer
            hideProgressBar
            closeOnClick
            theme="dark"
            position={gtXL ? 'bottom-right' : 'top-center'}
            closeButton={!gtXL}
            draggable="touch"
            draggablePercent={30}
          />
        </div>,
        document.body
      )}

      <TooltipProvider delayDuration={0}>
        <RouterProvider router={router} />
      </TooltipProvider>
    </>
  )
}

export default App
